import Vue from 'vue';

// Session-only on purpose (not localStorage): the date must be empty at each new session.
const state = Vue.observable({ date: null });

export function getProgressDateState() {
    return state;
}

export function setProgressDate(date) {
    state.date = date || null;
}

export function resetProgressDate() {
    state.date = null;
}
